module.exports = __webpack_public_path__ + "static/media/r211.66bd5df5.jpg";